'use strict';

var index = require('../define-properties/index.js');
var implementation$1 = require('./implementation.js');
var polyfill$1 = require('./polyfill.js');
var shim$1 = require('./shim.js');

var defineProperties = index;

var implementation = implementation$1;
var getPolyfill = polyfill$1;
var shim = shim$1;

var polyfill = getPolyfill();

defineProperties(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var object_assign = polyfill;

module.exports = object_assign;
